import React from 'react';
import { getPercentFromCountList } from '../../helpers/vote';
import styles from './VoteFullSize.module.css';
import { Percentage } from '../Percentage/Percentage';
import { CircularProgress } from '../CircularProgress/CircularProgress';
import { MadeIactivePro } from '../MadeIactivePro/MadeIactivePro';

const VoteFullSize = ({
  variants,
  title,
  currentState,
  questionFontSize,
  answerFontSize,
  varNumFontSize,
}) => {
  let percentList = getPercentFromCountList(
    (variants || []).map((el) => +el.count)
  );

  const isLong = title?.length > 120;
  const isTwo = variants?.length === 2;

  return (
    <div className={styles.container}>
      <div
        className={styles.wrapperVars}
        style={{
          justifyContent: title ? 'flex-start' : 'center',
        }}
      >
        {title && (
          <div className={styles.questionBlock}>
            <div
              className={styles.question}
              style={{
                fontSize: isLong
                  ? `${0.8 * questionFontSize}rem`
                  : `${questionFontSize}rem`,
              }}
            >
              {title}
            </div>
          </div>
        )}

        <div className={styles.vars}>
          {variants?.map((item, i) => (
            <div key={i} className={styles.var}>
              <div
                className={styles.varTextBlock}
                style={{
                  transform: variants.some((item) => item.varImgUrl)
                    ? 'translateY(0rem)'
                    : currentState === 'S1'
                    ? 'translateY(20rem)'
                    : 'translateY(0rem)',
                }}
              >
                <div
                  className={styles.varNumber}
                  style={{
                    fontSize: `${varNumFontSize}rem`,
                    height: `${1.6 * varNumFontSize}rem`,
                    width: `${1.8 * varNumFontSize}rem`,
                    minWidth: `${1.8 * varNumFontSize}rem`,
                  }}
                >
                  {i + 1}
                </div>
                <div
                  className={styles.varTitle}
                  style={{
                    fontSize: `${answerFontSize}rem`,
                    hyphens: isTwo ? 'manual' : 'auto',
                  }}
                >
                  {item.comment}
                </div>
              </div>

              <div
                className={styles.varResultBlock}
                style={{
                  width: isTwo ? '42rem' : '34rem',
                  height: isTwo ? '42rem' : '34rem',
                  opacity:
                    (currentState === 'S1' && item.varImgUrl) ||
                    currentState === 'S2'
                      ? 1
                      : 0,
                }}
              >
                <div className={styles.bgVarBlock}>
                  <div
                    className={styles.bgVar}
                    style={{
                      backgroundImage: `url(${item.varImgUrl})`,
                      opacity: currentState === 'S2' ? 0.5 : 1,
                    }}
                  />

                  {currentState === 'S2' && percentList[i] !== 0 && (
                    <Percentage id={i.toString()} value={percentList[i]} />
                  )}

                  {currentState === 'S2' && (
                    <div
                      className={styles.circularBlock}
                      style={{
                        width: isTwo ? '42rem' : '34rem',
                        height: isTwo ? '42rem' : '34rem',
                      }}
                    >
                      <CircularProgress percent={percentList[i]} />
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <MadeIactivePro />
    </div>
  );
};

export default React.memo(VoteFullSize);
